import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./main.css";
import Headers from "../../Components/headers/headers";
import Footer from "../../Components/footers/footer";

const Main = () => {
    const [query, setQuery] = useState("");
    const navigate = useNavigate();
    const [error, setError] = useState(null);

    const handleSearch = (e) => {
        if (e) e.preventDefault();
        if (query && query.trim()) {
            navigate(`/Loisresult?query=${encodeURIComponent(query)}`);
        } else {
            navigate("/Loisresult");
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            handleSearch(e);
        }
    };

    const handleAdvancedSearch = () => {
        navigate("/Loisresult");
    };

    return (
        <div className="page-wrapper">
            <Headers />

            <main className="hero-section">
                <div className="hero-content">
                    <div className="ia-badge">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#F57C00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
                        </svg>
                        <span>Propulsé par l'Intelligence Artificielle</span>
                    </div>

                    <h1 className="hero-title">
                        Toute la législation <span className="highlight">ivoirienne</span>
                    </h1>

                    <p className="hero-subtitle">
                        Accessible, Actualisée et Intelligente
                    </p>

                    <form className="search-bar" onSubmit={handleSearch}>
                        <input
                            type="text"
                            placeholder="Rechercher par mot-clé, numéro d'article ou thématique..."
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                            onKeyDown={handleKeyDown}
                            className="search-input"
                        />
                        <button type="submit" className="search-btn">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="11" cy="11" r="8"></circle>
                                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                            </svg>
                            Rechercher
                        </button>
                    </form>

                    <button className="advanced-search-btn" onClick={handleAdvancedSearch}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="4" y1="21" x2="4" y2="14"></line>
                            <line x1="4" y1="10" x2="4" y2="3"></line>
                            <line x1="12" y1="21" x2="12" y2="12"></line>
                            <line x1="12" y1="8" x2="12" y2="3"></line>
                            <line x1="20" y1="21" x2="20" y2="16"></line>
                            <line x1="20" y1="12" x2="20" y2="3"></line>
                            <line x1="1" y1="14" x2="7" y2="14"></line>
                            <line x1="9" y1="8" x2="15" y2="8"></line>
                            <line x1="17" y1="16" x2="23" y2="16"></line>
                        </svg>
                        Recherche avancée
                    </button>

                    <div className="hero-description">
                        <p>
                            <strong>DATAGREFFE</strong>{" "}
                            <span className="highlight-text">Legis</span>{" "}
                            révolutionne l'accès aux textes de loi, aux codes, aux traités, aux arrêtés, aux
                            règlements et à l'ensemble de la législation ivoirienne grâce à la puissance de l'IA.
                        </p>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default Main;